module.exports = __webpack_public_path__ + "img/pohled_z_venku_3.d79ac8e1.jpg";